import getCompositionsStore from 'actions/customer/lib/get_compositions_store';

export default function updateComposition(context, composition, newContent) {
  composition.replaceContent(newContent);

  const customerId = composition.customerId;
  getCompositionsStore(context, customerId).replace(composition);
  context.stores.localCompositions.set(customerId, composition);

  if (!composition.content.isEmpty()) {
    context.analytics.track('Conversation Response Updated', {
      customerId: composition.customerId,
      conversationId: composition.conversationId,
      compositionId: composition.id,
      contentType: composition.contentType(),
    });
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/composition/lib/update_composition.js